const D3Node = require('d3-node');
const R = require('ramda');

const drawCube = ({ colorScheme, cubieSize, size, spacing, state }) => {
  const color = getColor(colorScheme);

  const coordsX = getXCoords(cubieSize, size, spacing);
  const coordsY = getYCoords(cubieSize, size, spacing);

  const d3n = new D3Node();

  const svg = d3n
    .createSVG(
      size * 4 * cubieSize + 4 * spacing,
      size * 3 * cubieSize + 3 * spacing
    )
    .attr('style', `stroke-linejoin:round;`)
    .append('g');

  R.addIndex(R.forEach)(
    (cubie, index) =>
      svg
        .append('rect')
        .attr('x', coordsX(index))
        .attr('y', coordsY(index))
        .attr('width', cubieSize)
        .attr('height', cubieSize)
        .attr('fill', color(cubie))
        .attr('stroke', 'black'),
    state
  );

  return d3n.svgString();
};

const getColor = ({ U, R: Right, F, D, L, B }) =>
  R.cond([
    [R.includes(R.__, ['U', 0]), R.always(U)],
    [R.includes(R.__, ['R', 1]), R.always(Right)],
    [R.includes(R.__, ['F', 2]), R.always(F)],
    [R.includes(R.__, ['D', 3]), R.always(D)],
    [R.includes(R.__, ['L', 4]), R.always(L)],
    [R.T, R.always(B)],
  ]);

const getSideColumn = R.cond([
  [R.equals(1), R.always(2)],
  [R.equals(4), R.always(0)],
  [R.equals(5), R.always(3)],
  [R.T, R.always(1)],
]);

const getSideRow = R.cond([
  [R.equals(0), R.always(0)],
  [R.equals(3), R.always(2)],
  [R.T, R.always(1)],
]);

const sideNumber = (index, size) => Math.floor(index / size ** 2);

const getColumn = (idx, size, side) =>
  (idx % size) + getSideColumn(side) * size;

const getRow = (idx, size, side) =>
  Math.floor((idx / size) % size) + getSideRow(side) * size;

const getXCoords = R.curry((cubieSize, size, spacing, index) => {
  const column = getColumn(index, size, sideNumber(index, size));
  return spacing * (Math.floor(column / size) + 1) + cubieSize * column;
});

const getYCoords = R.curry((cubieSize, size, spacing, index) => {
  const row = getRow(index, size, sideNumber(index, size));
  return spacing * (Math.floor(row / size) + 1) + cubieSize * row;
});

module.exports = {
  getColor,
  getSideColumn,
  getSideRow,
  sideNumber,
  getColumn,
  getRow,
  drawCube,
};
